
import util from '@/libs/util'
import common from '@/libs/common.mixin'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default{
mixins: [common],
components: {
Tab,
TabItem,
Flexbox,
FlexboxItem,
},
data () {
return {
tab_index: 0,
sub_tab_index: 0,
active_ability_id: 1
}
},
mounted () {
this.init()
},
methods: {
getLessons (grade) {
let lessons = this.lessons,
result = [],
filter = (item)=>{
return item.product_level_did==this.current_product_did
&&(item.ability_did==this.active_ability_id
||item.ability_did==0)
&&((item.fit_grade_start<=grade&&item.fit_grade_end>=grade)
||(item.fit_grade_start==0&&item.fit_grade_end==0))
}

result = lessons.filter(filter)

return result
},
init () {
this.init_lesson()
this.init_product_level()
},
init_lesson () {
this.$http.get('/sapi/open/global/?name=lessons')
.then(response=>{
this.$store.commit('updateGlobalVar',{name:'lessons',data:response.body.data})
}).catch(response=>{
this.toast(response.body.message,'text')
})
},
init_product_level () {
this.$http.get('/sapi/open/global/?name=dicts')
.then(response=>{
this.$store.commit('updateGlobalVar',{name:'dicts',data:response.body.data})
this.active_ability_id = this.abilities[0].did
}).catch(response=>{
this.toast(response.body.message,'text')
})
},
getLesson (lesson_list) {
let [list,index] = [[],this.tab_index]
if(lesson_list && lesson_list.length>0){
list = lesson_list.filter(l=>l.product_level==(index+1))
}
return list
}
},
computed: {
abilities () {
let list = this.dicts('lesson_ability'),
result = []
list.forEach(l=>{
let index = result.findIndex(r=>r.did==l.pid)
if(index==-1){
result.push(l)
}else{
if(result[index].children){
result[index].children.push(l)
}else{
result[index].children = [l]
}
}
})

return result
},
current_ability () {
let active_ability_id = this.active_ability_id,
abilities = this.abilities,
result = {}

result = abilities.find(a=>a.did==active_ability_id)||{}




return result
},
tabs () {
return this.dicts('product_level')
},
lessons () {
return this.gvars('lessons')
},
current_product_did () {
let index = this.tab_index,
result = this.tabs[index]?this.tabs[index].did:0
return result
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/lesson-map.vue